import React from 'react'
import { Typography } from '@material-ui/core'
import { ReactComponent as TableNotFoundIcon } from 'app/components/icons/table-not-found-icon.svg'
import { FormattedMessage } from 'react-intl'

const EmptyDataTable = () => {
  return (
    <div className="m-60">
      <div className="mx-auto flex w-fit">
        <TableNotFoundIcon />
      </div>
      <Typography className="text-16 font-bold text-neutrals-800 my-5 flex justify-center">
        <FormattedMessage id="text.no.results" />
      </Typography>
      <Typography className="text-neutrals-400 my-2 flex justify-center">
        <FormattedMessage id="text.adjusting.search" />
      </Typography>
    </div>
  )
}

export default EmptyDataTable
